import * as React from "react";
import "./styles.css";
import { TextInputCounter } from "../../components/TextInputCounter/TextInputCounter";
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  SelectInput,
  ImageInput,
  Toolbar,
  SaveButton,
  useNotify,
  ImageField,
  useRecordContext,
  useDataProvider,
} from "react-admin";
import { enabledFlags } from "../../constants/utils";
import useFileUpload from "../../hooks/useFileUpload";
import { useEffect } from "react";
import { RaCreateWrapper } from "../../components/RaCreateWrapper";

interface IActivityCreate {
  [key: string]: any;
}

const ActivityCreateToolbar = ({ files, ...props }: any) => {
  return (
    <Toolbar {...props}>
      <SaveButton
        transform={({ ...data }: IActivityCreate) => {
          const mappedRequest = {
            ...data,
            parentId: data.parentId === "" ? null : data.parentId,
            enabled: data.enabled == true || data.enabled == "true",
          };
          return {
            ...mappedRequest,
            ...files,
          };
        }}
        type="button"
      />
    </Toolbar>
  );
};

export const ActivitiesCreate = () => {
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const [parentActivities, setParentActivities] = React.useState<
    {
      id: null | any;
      name: string;
    }[]
  >([]);

  useEffect(() => {
    const fetchParentActivities = async () => {
      const { data } = await dataProvider.getParentActivities();

      const mappedParentActivities = data.map((parentActv: any) => {
        return {
          id: parentActv.id,
          name: parentActv.name,
        };
      });

      setParentActivities(mappedParentActivities);
    };
    fetchParentActivities();
  }, []);

  // Activities Files
  const [activityFiles, setActivityFiles] = React.useState<{
    iconId: null | any;
  }>({
    iconId: null,
  });

  // Used to track the uploaded files and show in progress or error.
  const [uploadedFileNames, setUploadFileNames] = React.useState<{
    [key: string]: string | boolean;
  }>({});

  const { uploadFile } = useFileUpload();
  const handlePrefileUpload = async (name: "iconId", files: File[]) => {
    const fileName = files[0].name;
    notify(`Uploading file... ${fileName}`);

    setUploadFileNames({ ...uploadedFileNames, [fileName]: "Uploading..." });

    const asset = await uploadFile(files[0], name);
    if (asset !== undefined) {
      const newValue = asset.id;
      setActivityFiles({ ...activityFiles, [name]: newValue });
      notify(`Upload completed! File: ${fileName}`);
      setUploadFileNames({ ...uploadedFileNames, [fileName]: true });
    } else {
      notify(`Error uploading file! ${fileName}`);
      setUploadFileNames({
        ...uploadedFileNames,
        [fileName]: "Error uploading file, remove and try again.",
      });
    }
  };

  const FileFieldWithContext = (props: any) => {
    const { title } = useRecordContext();

    if (!Object.hasOwn(uploadedFileNames, title)) {
      return null;
    }

    if (uploadedFileNames[title] === true) {
      return props.children;
    } else {
      return <p>{uploadedFileNames[title]}</p>;
    }
  };

  const onFileRemoval = (target: string, _file: any) => {
    setActivityFiles({ ...activityFiles, [target]: null });
    return true; // is handled from frontend
  };
  return (
    <RaCreateWrapper title="New Activity">
      <SimpleForm toolbar={<ActivityCreateToolbar files={activityFiles} />}>
        <div className="form-text-input-row">
          <TextInputCounter
            formClassName="form-text-input-field"
            source="name"
            validate={[required()]}
          />
          <SelectInput
            choices={parentActivities}
            source="parentId"
            label="Category"
            validate={[]}
          />
          <SelectInput
            choices={enabledFlags}
            source="enabled"
            label="Enabled?"
            defaultValue="false"
            validate={[required()]}
          />
        </div>

        <h4 className="heading-file-uploads">Icon</h4>

        <div className="activity-icons-grid">
          <ImageInput
            source="iconId"
            label="Activity Icon (.png, .jpg, .jpeg)"
            validate={[required()]}
            accept={"image/png,image/jpg,image/jpeg"}
            options={{
              onDropAccepted: handlePrefileUpload.bind(null, "iconId"),
            }}
            validateFileRemoval={(file: any) => onFileRemoval("iconId", file)}
          >
            <FileFieldWithContext>
              <ImageField source="src" title="title" />
            </FileFieldWithContext>
          </ImageInput>
        </div>
      </SimpleForm>
    </RaCreateWrapper>
  );
};
